<template>
  <div class='banner'>
    <div class='banner-content'>
      <div>
        <h3 v-html='data.title'></h3>
        <p v-html="data.desc"></p>
        <div>
          <button class='btn1' v-if='data.buttonText' @click.stop="data.buttonCallback">{{data.buttonText}}</button>
          <button class='btn2' v-if='data.buttonText1' @click.stop="data.buttonCallback1">{{data.buttonText1}}</button>
        </div>
      </div>
      <img class='banner-image' :src='data.image'/>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'Banner',
    props: {
      data: {
        required: true,
        type: Object,
      }
    }
  }
</script>

<style lang="less" scoped>
.banner {
  background: linear-gradient(134deg,#2544a1 3%, #152664 96%);
  .banner-content {
    margin: 0 auto;
    width: 1149px;
    text-align: left;
    position: relative;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding-bottom: 24px;
    >div {
      height: 100%;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: flex-start;
      width: 600px;
      h3{
        font-size: 32px;
        color: #FFFFFF;
        font-weight: 600;
      }
      p{
        margin-top: 20px;
        font-size: 18px;
        color: #FFFFFF;
        font-weight: 400;
        line-height: 34px;
      }
      .btn1,.btn2{
        float: left;
        margin-top: 40px;
        transition: all 0.3s;
        height: 50px;
        min-width: 140px;
        padding-left: 15px;
        padding-right: 15px;
        background: linear-gradient(325deg,#3b71f2 7%, #8da8ff 95%);
        border-radius: 25px;
        border: none;
        color: #fff;
        cursor: pointer;
        outline: none;
        font-size: 16px;
        &:hover {
          opacity: 0.9;
        }
      }
      .btn2{
        float: left;
        margin-left: 30px;
      }
    }
    img {
      width: 300px;
      height: 300px;
    }
  }
}
</style>